import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

export const hasDigitalMarketingPermission = (): boolean => swSettings.user.hasDM || swSettings.user.isSimilarWebUser;

export const hasMarketResearchPermission = (): boolean => swSettings.user.hasMR || swSettings.user.isSimilarWebUser;

export const hasDashboardPermission = (): boolean => isAvailable(swSettings?.components?.Dashboard);

export const hasDigitalSuiteCompetitivePermission = (): boolean =>
    isAvailable(swSettings?.components?.DigitalSuiteCompetitveSection);

export const hasPremiumFeaturePermission = (): boolean => isAvailable(swSettings?.components?.PremiumSection);

export const hasSuppressionListPermissions = (): boolean => swSettings?.user?.hasSlAccess;

export const hasCrmPermissions = (): boolean => swSettings?.user?.hasCrmAccess;

export const LOCKED_ICON_NAME = "spark";
